import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'iview';
import locale from 'iview/src/locale/lang/mn-MN';
import BootstrapVue from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueYouTubeEmbed from 'vue-youtube-embed'
import ECharts from 'vue-echarts'
import loading from 'vuejs-loading-screen'

import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import mapInit from 'highcharts/modules/map'
import VueSocialSharing from 'vue-social-sharing'

import "./sass/app.scss"
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'swiper/swiper.scss'
import 'swiper/swiper-bundle.css'
import 'echarts-gl'

import {i18n} from '@lambda-platform/locale';


import {getDate} from "./utils/date";
import {getNumber} from "./utils/number";

mapInit(Highcharts);

Vue.config.productionTip = false;
Vue.use(VueSocialSharing);
Vue.use(HighchartsVue);
Vue.use(iView, {locale});
Vue.use(BootstrapVue);
Vue.use(VueYouTubeEmbed);
Vue.component('v-chart', ECharts);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
Vue.use(loading, {
  // bg: 'rgb(0, 0, 0, 0.4)',
  bg: '#ffffff',
  icon: 'spinner',
  size: 3,
  icon_color: '#1054b1',
});

Vue.filter("date", (value) => {
  return getDate(value);
});
Vue.filter("number", (value) => {
 return getNumber(value);
});
new Vue({
  router,
  render: h => h(App),
  i18n,
}).$mount('#app');
